import { NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';

@Component({
  selector: 'app-painel-expansao',
  standalone: true,
  imports: [MatExpansionModule, NgIf],
  templateUrl: './painel-expansao.component.html',
  styleUrl: './painel-expansao.component.scss',
})
export class PainelExpansaoComponent {
  estadoDeAberturaDoPainel: boolean = false;

  @Input({ required: true }) titulo: string = '';
  @Input() habilitado: boolean = true;

  // #1128: controle externo opcional do estado (accordion "um por vez").
  // Quem nao vincula [expandido] continua com o comportamento self-managed (ex.: pqr).
  @Input() set expandido(valor: boolean) {
    this.estadoDeAberturaDoPainel = this.habilitado ? !!valor : false;
  }
  @Output() expandidoChange = new EventEmitter<boolean>();

  public abrirPainel(): void {
    this.estadoDeAberturaDoPainel = this.habilitado && true;
  }

  public fecharPainel(): void {
    this.estadoDeAberturaDoPainel = false;
  }
}
